import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import SelectTable from "../components/SelectTable";
import SelectedTable from "../components/SelectedTable";
import DoneSearchReceipts from "../components/DoneSearchReceipts";

const OrdersDone = (props) => {
  const [receiptsSearchCaseHandler, setReceiptsSearchCaseHandler] = useState(
    []
  );
  const [pageCount, setPageCount] = useState(0);
  const [page, setPage] = useState(1);

  //getting the data from search component
  const getReceiptData = (data, count) => {
    setReceiptsSearchCaseHandler(data);
    setPageCount(count);
  };
  //getting the data from the pagination
  const getPage = (data) => {
    setPage(data);
  };
  return (
    <React.Fragment>
      <Grid container spacing={4}>
        <Grid xs={12}>
          <DoneSearchReceipts getReceiptData={getReceiptData} page={page} />
        </Grid>
        <Grid xs={12}>
          <SelectedTable />
        </Grid>
        <Grid xs={12}>
          <SelectTable
            data={receiptsSearchCaseHandler}
            getPage={getPage}
            pageCount={pageCount}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default OrdersDone;
